<template>
  <app-bottom-sheet class="grid gap-4">
    <growth-contact-button
      block
      origin="trainer"
      origin_page_action="main_contact_cta"
      :origin_page_id="teacher.slug!"
      size="lg"
    >
      {{ $t("teacher.page.contact.cta") }}
    </growth-contact-button>

    <app-button
      v-if="nextCourses.length > 0"
      v-smooth-scroll
      color="dark"
      href="#nextSessions"
      variant="link"
    >
      Prochaines sessions
    </app-button>
  </app-bottom-sheet>
</template>

<script lang="ts" setup>
import type { CourseListView } from "~/business-areas/course/composables/course-list.hook";
import type { TeacherPageView } from "~/business-areas/teacher/teacher.model";

defineProps<{
  teacher: TeacherPageView;
  nextCourses: CourseListView[];
}>();
</script>
